import { JsSdkEventEmitInstance } from "../utils/JsSdkEventEmit";
import { OspToastInstance } from "./types";

export const ToastEventName = "osp.ui.toast";

export class OspToast {
  static info: OspToastInstance["info"] = (options) => {
    JsSdkEventEmitInstance.emitEvent(ToastEventName, {
      ...options,
      type: "info",
    });
  };

  static success: OspToastInstance["success"] = (options) => {
    JsSdkEventEmitInstance.emitEvent(ToastEventName, {
      ...options,
      type: "success",
    });
  };

  static error: OspToastInstance["error"] = (options) => {
    JsSdkEventEmitInstance.emitEvent(ToastEventName, {
      ...options,
      type: "error",
    });
  };

  static warning: OspToastInstance["warning"] = (options) => {
    JsSdkEventEmitInstance.emitEvent(ToastEventName, {
      ...options,
      type: "warning",
    });
  };
}
